import React from 'react';
import { NoDataAvailable, formatPercentage } from '../helpers/helper';
import PropTypes from 'prop-types';

export default function EmailCard({ emailStats }) {
  const { sent, opened, clicked } = emailStats;

  const percentageOpened = isNaN(opened / sent) ? 1 : opened / sent;
  const percentageClicked = isNaN(clicked / sent) ? 1 : clicked / sent;

  const fullCircle = {
    radius: 130,
    ...calculateCircleAttributes(130, 1)
  };

  const emailsOpenedCircle = {
    radius: 120,
    ...calculateCircleAttributes(120, percentageOpened)
  };

  const emailsClickedCircle = {
    radius: 110,
    ...calculateCircleAttributes(110, percentageClicked)
  };

  return (
    <div className="dashboard-card dashboard-card-full d-flex flex-column">
      <h3 className="d-title">Email</h3>
      {sent === 0 ? (
        <NoDataAvailable/>
      ) : (
        <React.Fragment>
          <div className="d-flex justify-content-center">
            <div className="mr-2 d-flex align-items-center">
              <span className="opened-emails legend-color mr-2"></span>
              {formatPercentage(percentageOpened)}% opened
            </div>
            <div className="ml-2 d-flex align-items-center">
              <span className="clicked-emails legend-color mr-2"></span>
              {formatPercentage(percentageClicked)}% clicked
            </div>
          </div>
          <svg className="flex-1">
            <circle cx="50%" cy="50%" fill="none" r="125" stroke="#F5F4F4" strokeWidth="40"></circle>
            <circle
              className="email-circle full"
              cx="50%"
              cy="50%"
              fill="none"
              r={fullCircle.radius}
              strokeDashoffset={fullCircle.strokeOffset}
              strokeWidth="10"
              style={{
                '--startingValue': fullCircle.blankStrokeDashArray,
                '--endingValue': fullCircle.strokeDashArray
              }}
            ></circle>
            <circle
              className="email-circle opened"
              cx="50%"
              cy="50%"
              fill="none"
              r={emailsOpenedCircle.radius}
              strokeDashoffset={emailsOpenedCircle.strokeOffset}
              strokeWidth="10"
              style={{
                '--startingValue': emailsOpenedCircle.blankStrokeDashArray,
                '--endingValue': emailsOpenedCircle.strokeDashArray
              }}
            ></circle>
            <circle
              className="email-circle clicked"
              cx="50%"
              cy="50%"
              fill="none"
              r={emailsClickedCircle.radius}
              strokeDashoffset={emailsClickedCircle.strokeOffset}
              strokeWidth="10"
              style={{
                '--startingValue': emailsClickedCircle.blankStrokeDashArray,
                '--endingValue': emailsClickedCircle.strokeDashArray
              }}
            ></circle>
            <text
              className="dashboard-circle-highlight-text"
              dominantBaseline="middle"
              textAnchor="middle"
              x="50%"
              y="46%"
            >
              {sent}
            </text>
            <text dominantBaseline="middle" style={{ fontSize: '15px' }} textAnchor="middle" x="50%" y="54%">
              Total Emails Sent
            </text>
          </svg>
        </React.Fragment>
      )}
    </div>
  );
}

function calculateCircleAttributes(radius, decimalPercentageOfCircle) {
  // this function utilizes stroke-dash-array to create a SVG circle that is only partially filled
  // with passing in two arguments to stroke-dash-array, we are setting the first argument to the
  // dash and the second argument as the gap. with both of these numbers combined equaling the total
  // circumference of the circle, we can create a circle that only shows a portion of itself

  const circumference = 2 * Math.PI * radius;

  // to start svg circle from top, we must first rotate the circle by 90 degrees
  const strokeOffset = .25 * circumference;

  // visibleStroke and invisibleStroke must combine to equal the circumference
  const visibleStroke = decimalPercentageOfCircle * circumference;
  const invisibleStroke = circumference - visibleStroke;
  const strokeDashArray = `${visibleStroke},${invisibleStroke}`;
  const blankStrokeDashArray = `0,${circumference}`;
  return { strokeDashArray: strokeDashArray, strokeOffset: strokeOffset, blankStrokeDashArray: blankStrokeDashArray };
}

EmailCard.propTypes = {
  emailStats: PropTypes.object.isRequired,
};
